import { render, staticRenderFns } from "./like.vue?vue&type=template&id=1e4187dc&scoped=true"
import script from "./like.vue?vue&type=script&lang=ts"
export * from "./like.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4187dc",
  null
  
)

export default component.exports